import { __extends } from 'tslib';
import * as React from 'react';
import { classNames, validatePropType, UitkContextProvider } from 'uitk-react-utils';
import styles from './uitk-scrim.css';
import { UitkScrimType, UitkScrimColorType } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkScrim = /** @class */ (function (_super) {
    __extends(UitkScrim, _super);
    function UitkScrim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkScrim.prototype.render = function () {
        var _a, _b;
        var _c = this.props, tag = _c.tag, type = _c.type, children = _c.children, className = _c.className, color = _c.color;
        var Tag = '';
        var isBottomScrim = type === UitkScrimType.BOTTOM;
        var isOverlayScrim = type === UitkScrimType.OVERLAY;
        if (tag && tag !== '') {
            Tag = tag;
        }
        else {
            Tag = 'div';
        }
        var wrapperClassNames = getClassNameList('uitk-scrim', className, (_a = {},
            _a["".concat(type)] = validatePropType(type, UitkScrimType),
            _a), (_b = {},
            _b["".concat(color)] = validatePropType(color, UitkScrimColorType),
            _b));
        var contextData = {
            bottomScrimContext: isBottomScrim,
            overlayScrimContext: isOverlayScrim
        };
        return (React.createElement(Tag, { className: wrapperClassNames },
            React.createElement(UitkContextProvider, { config: { context: 'uitk-scrim-context', data: contextData } }, children)));
    };
    UitkScrim.displayName = 'UitkScrim';
    UitkScrim.defaultProps = {
        type: UitkScrimType.BOTTOM
    };
    return UitkScrim;
}(React.PureComponent));

export { UitkScrim };
